export default __webpack_public_path__ + "static/media/logout.dd0d24e2.svg";